// App Providers
// Combines all context providers into a single component

import React from 'react';
import { OcelProvider } from '../../stores/OcelContext';
import { GlobalFilterProvider } from '../../stores/GlobalFilterContext/GlobalFilterContext';
import { CacheSettingsProvider } from '../../stores/CacheSettingsContext/CacheSettingsContext';
import { GraphDataProvider } from '../../stores/GraphDataContext';
import { SidebarProvider } from '../../components/layout/Sidebar';

/**
 * AppProviders - Wraps the application with all necessary context providers
 * Provider order matters - outer providers are available to inner providers
 *
 * Note: WorkshopModeProvider is NOT here — it lives in index.jsx, above
 * BrowserRouter, because App.jsx renders <AppProviders> as a child partway
 * through its own JSX (so App.jsx's own hooks sit outside this subtree) and
 * LandingPage/ETLProjectPage are routed outside AppProviders entirely. A
 * single Provider instance up there is a true ancestor of all of them.
 */
const AppProviders = ({ children }) => {
  return (
    <GraphDataProvider>
      <CacheSettingsProvider>
        <OcelProvider>
          <GlobalFilterProvider>
            <SidebarProvider>
              {children}
            </SidebarProvider>
          </GlobalFilterProvider>
        </OcelProvider>
      </CacheSettingsProvider>
    </GraphDataProvider>
  );
};

export default AppProviders;
